/**
 * Style memory: the client-side, per-course record of the last media style an author picked.
 *
 * Purely a convenience for preselecting the dropdown — nothing server-side exists, and no
 * generation's record depends on it. It remembers the style *key* rather than the row id, because
 * ids are per-database while the key names the same style everywhere.
 *
 * Storage is best-effort throughout: a browser that refuses it costs the author one re-pick.
 */

const STORAGE_PREFIX = 'creatorMediaStyle:';

const storageAvailable = (): boolean => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const buildStorageKey = (courseId: number): string => `${STORAGE_PREFIX}${courseId}`;

export const readRememberedMediaStyleKey = (courseId: number): string | null => {
  if (!storageAvailable()) return null;

  try {
    const remembered = window.localStorage.getItem(buildStorageKey(courseId));
    return remembered || null;
  } catch {
    return null;
  }
};

export const rememberMediaStyleKey = (courseId: number, mediaStyleKey: string): void => {
  if (!storageAvailable() || !mediaStyleKey) return;

  try {
    window.localStorage.setItem(buildStorageKey(courseId), mediaStyleKey);
  } catch {
    // An author who cannot be remembered simply picks again next time.
  }
};
